module.exports = "/_next/static/images/eb17103335664d71270398648d26b90d-holding-device-smile@2x.jpg";